import { Directive, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { List } from 'immutable';
import { Observable, Subject } from 'rxjs';
import { WindowRefService } from 'i2g-ng-utils';
import { filter, takeUntil } from 'rxjs/operators';

export interface IWaypoint {
  element: any;
  handler: (direction?: WaypointDirectionsEnum) => void;
  offset: number;
  fromBottom: boolean;
  context?: any;
}

export enum WaypointDirectionsEnum {
  up = 'up',
  down = 'down',
}

export enum WaypointActionTriggersEnum {
  refresh = 'refresh',
}

@Directive({
  selector: '[waypoints]',
})
export class WaypointsDirective implements OnInit, OnChanges, OnDestroy {
  @Input() waypoints: List<IWaypoint>;
  @Input() waypointActionTriggers: Observable<WaypointActionTriggersEnum>;

  private _waypoints: any[];
  private _Waypoint: any;
  private _windowRef: any;
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  constructor(private _windowRefService: WindowRefService) {}

  ngOnChanges(changes) {
    let waypoints = changes.waypoints && changes.waypoints.currentValue;

    if (!this._Waypoint) {
      this._windowRef = this._windowRefService.nativeWindow;
      this._Waypoint = this._windowRef.Waypoint;
    }

    if (!!waypoints) {
      this.destroyWaypoints();

      this.setupWaypoints(waypoints);
    }
  }

  ngOnInit() {
    this.setupWaypoints(this.waypoints);
  }

  setupWaypoints(waypoints) {
    if (this._Waypoint) {
      this._waypoints = (waypoints || []).map((waypoint: IWaypoint) => {
        const waypointElement = waypoint.element;
        const waypointContext = waypoint.context || this._windowRef;

        return new this._Waypoint({
          element: waypointElement,
          handler: (direction: WaypointDirectionsEnum) =>
            waypoint.handler(direction),
          offset: waypoint.fromBottom
            ? () =>
                waypointContext.clientHeight -
                waypointElement.clientHeight +
                waypoint.offset
            : waypoint.offset,
          context: waypointContext,
        });
      });

      if (this.waypointActionTriggers) {
        this.waypointActionTriggers
          .pipe(
            filter(
              (actionTrigger: WaypointActionTriggersEnum) =>
                actionTrigger === WaypointActionTriggersEnum.refresh
            ),
            takeUntil(this._destroyed)
          )
          .subscribe((actionTrigger: WaypointActionTriggersEnum) =>
            this._Waypoint.refreshAll()
          );
      }
    }
  }

  destroyWaypoints() {
    if (this._waypoints) {
      this._waypoints.forEach(
        (waypoint: any) => waypoint && waypoint.destroy()
      );
    }
  }

  ngOnDestroy() {
    this.destroyWaypoints();

    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
